let config = {}

if (process.env.NODE_ENV === 'production') {
  config = {
    url: 'https://api.gentlewomanonline.com'
  }
} else {
  config = {
    url: 'https://staging-api.gentlewomanonline.com'
  }
}

module.exports = config
